import { useAtom } from "@reatom/npm-react";
import { useGravityDevice } from "src/hooks/useGravityDevice";

import { isOpenPromotionModalAtom } from "../../store/atoms/promotionModalAtom";
import { PromotionModal, PromotionSheet } from "./components";

export const ResponsivePromotionWidget = () => {
  const { isMobile } = useGravityDevice();

  const [isOpen, setIsOpen] = useAtom(isOpenPromotionModalAtom);

  const handleOnClose = () => setIsOpen((prev) => !prev);

  if (isMobile) {
    return <PromotionSheet open={isOpen} onClose={handleOnClose} />;
  }
  return <PromotionModal open={isOpen} onClose={handleOnClose} />;
};
